import React, { useCallback } from 'react'
import { Loading } from 'components/Loading'
import { useFetchOne } from 'utils/api/useFetch'

import { TradingAccountTab } from '../Navigation/TradingAccountNavigation'
import { WelcomeTradingAccountNavigation } from '../Navigation/WelcomeTradingAccountNavigation'
import TradingAccountPendingOrdersTable from './TradingAccountPendingOrdersTable'

import '../TradingAccount.scss'

import { useApiClient } from '../../../../utils/api/ApiClient'
import { TradingAccountsApiClient } from '../../../../utils/api/tradingAccountsApi'

interface Props {
  data: {
    id: string
    name: string
  }
}

const WelcomeTradingAccountPendingOrdersPage: React.FC<Props> = ({ data }) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const fetchPendingOrders = useCallback(
    () => tradingAccountsApiClient.getWelcomeTradingAccountPendingOrders(data.id),
    [data.id] // eslint-disable-line react-hooks/exhaustive-deps
  )
  const { data: pendingOrders = [], isLoading } = useFetchOne(fetchPendingOrders)

  return (
    <React.Fragment>
      <WelcomeTradingAccountNavigation data={data} isEdit={false} tab={TradingAccountTab.Orders} />
      <Loading isLoading={isLoading}>
        <TradingAccountPendingOrdersTable pendingOrders={pendingOrders} />
      </Loading>
    </React.Fragment>
  )
}

export default WelcomeTradingAccountPendingOrdersPage
